import { pageInfo, uploadOrder, downloadTemplate, saveData, editData, deleteData, initAdd, orderEdit, materilePage, preferenceSet, orderPreSubmit, orderSubmit, materilePrice, getCreditBalanceData, getMoqSettingInfo, intOrderSaveDetail, orderSaveData, specialAddressBackup } from './../api';
import { shipToFmc, soldToList, endUser, sales, endUserAndSeller, shipTo } from '../../../../api';
import { Message } from 'element-ui';
const carrier = {
  namespaced: true,
  state: {
    successCode: 200,
    total: 0,
    pageResp: null,
    uploadOrderResp: null,
    downloadTemplateData: null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initAddObj: null,
    materilePageObj: null,
    preferenceSetResp: null,
    orderPreSubmitObj: null,
    orderSubmitResp: null,
    shipToFmcObj: null,
    endUserObj: null,
    salesObj: null,
    materilePriceObj: null,
    endUserAndSellerObj: null,
    creditBalance: null,
    soldToObj: null,
    moqSettingObj: null,
    orderSaveObj: null,
    orderSaveResp: null,
    orderEditResp: null,
    shipToObj: null,
    specialAddressBackupObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      if (data.code === state.successCode) {
        Message({ showClose: true, message: data.msg, type: 'success' });
      }
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPLOAD_ORDER(state,data){
      state.uploadOrderResp = data;
    },
    DOWN_LOAD_TEMPLATE(state,data){
      state.downloadTemplateData = data;
    },
    SAVE_DATA(state, data) {
      state.addResp = data
    },
    EDIT_DATA(state, data) {
      state.editResp = data
    },
    DELETE_DATA(state, data) {
      state.deleteResp = data
    },
    INIT_ADD_DATA(state, data) {
      state.initAddObj = data.obj || {};
    },
    MATERILE_PAGE_DATA(state, data) {
      // if (data.code === state.successCode) {
      //   Message({ showClose: true, message: data.msg, type: 'success' });
      // }
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    PREFERENCE_SET_DATA(state, data) {
      state.preferenceSetResp = data
    },
    ORDER_PRE_SUBMIT_DATA(state, data) {
      state.orderPreSubmitObj = data;
    },
    ORDER_SUMBIT_DATA(state, data) {
      state.orderSubmitResp = data
    },
    SHIP_TO_FMC_DATA(state, data) {
      state.shipToFmcObj = data.obj || [];
    },
    END_USER_DATA(state, data) {
      state.endUserObj = data;
    },
    END_USER_AND_SELLER_DATA(state, data) {
      state.endUserAndSellerObj = data;
    },
    SALES_DATA(state, data) {
      state.salesObj = data.obj || [];
    },
    MATERILE_PRICE(state, data) {
      state.materilePriceObj = data;
    },
    credit_data(state, data) {
     state.creditBalance = data.obj.creditBalance;
    },
    INIT_SOLDTO_DATA (state, data){
      state.soldToObj = data.obj || [];
    },
    MOQ_SETTING_DATA(state, data){
      state.moqSettingObj = data.obj || [];
    },
    INTORDERSAVE_DETAIL_DATA(state, data){
      state.orderSaveObj = data.obj || {};
    },
    ORDER_SAVE_DATA(state, data) {
      state.orderSaveResp = data
    },
    ORDER_EDIT_DATA(state, data) {
      state.orderEditResp = data.obj || {}
    },
    SHIP_TO_DATA(state, data) {
      state.shipToObj = data.obj || [];
    },
    SPECIAL_ADDRESS_BACKUP_DATA(state, data) {
      state.specialAddressBackupObj = data.obj || [];
    }
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //批量上传
    async uploadOrder({commit}, obj){
      let resp = await uploadOrder(obj);
      commit('UPLOAD_ORDER', resp);
    },
    //模版下载
    async downloadTemplate({commit}, obj){
      let resp = await downloadTemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //新增保存事件
    async saveData({ commit }, obj) {
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //修改保存事件
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //信贷信息
    async initAddData({ commit }, obj) {
      let resp = await initAdd(obj);
      commit('INIT_ADD_DATA', resp);
    },
    //产品列表
    async materilePageData({ commit }, obj) {
      let resp = await materilePage(obj);
      commit('MATERILE_PAGE_DATA', resp);
    },
    //偏好设置
    async preferenceSetData({ commit }, obj) {
      let resp = await preferenceSet(obj);
      commit('PREFERENCE_SET_DATA', resp);
    },
    //预提交订单
    async orderPreSubmitData({ commit }, obj) {
      let resp = await orderPreSubmit(obj);
      commit('ORDER_PRE_SUBMIT_DATA', resp);
    },
    //提交订单
    async orderSubmitData({ commit }, obj) {
      let resp = await orderSubmit(obj);
      commit('ORDER_SUMBIT_DATA', resp);
    },
    //收货方信息
    async shipToFmc({ commit }, obj) {
      let resp = await shipToFmc(obj);
      commit('SHIP_TO_FMC_DATA', resp);
    },
    //终端客户
    async endUserData({ commit }, obj) {
      let resp = await endUser(obj);
      commit('END_USER_DATA', resp);
    },

    async endUserAndSeller({ commit }, obj) {
      let resp = await endUserAndSeller(obj);
      commit('END_USER_AND_SELLER_DATA', resp);
    },
    //销售
    async salesData({ commit }, obj) {
      let resp = await sales(obj);
      commit('SALES_DATA', resp);
    },

    //价格
    async materilePriceData({ commit }, obj) {
      let resp = await materilePrice(obj);
      commit('MATERILE_PRICE', resp);
    },
    //查询信贷余额
    async getCreditBalanceData({ commit }, obj) {
      let resp = await getCreditBalanceData(obj);
      commit('credit_data', resp);
    },
    //售达方信息
    async soldToData({ commit }, obj) {
      let resp = await soldToList(obj);
      commit('INIT_SOLDTO_DATA', resp);
    },
    //查询经销商对应的送达方起订量数据
    async getMoqSettingInfo({ commit }, obj) {
      let resp = await getMoqSettingInfo(obj);
      commit('MOQ_SETTING_DATA', resp);
    },
    //查询订单保存的临时信息
    async intOrderSaveDetail({ commit }, obj) {
      let resp = await intOrderSaveDetail(obj);
      commit('INTORDERSAVE_DETAIL_DATA', resp);
    },
    //保存订单
    async orderSaveData({ commit }, obj) {
      let resp = await orderSaveData(obj);
      commit('ORDER_SAVE_DATA', resp);
    },
    //保存订单
    async orderEdit({ commit }, obj) {
      let resp = await orderEdit(obj);
      commit('ORDER_EDIT_DATA', resp);
    },
    //收货方信息
    async shipTo({ commit }, obj) {
      let resp = await shipTo(obj);
      commit('SHIP_TO_DATA', resp);
    },
    //特殊地址备用列表
    async specialAddressBackup({ commit }, obj) {
      let resp = await specialAddressBackup(obj);
      commit('SPECIAL_ADDRESS_BACKUP_DATA', resp);
    }
  }
}
export default carrier



// WEBPACK FOOTER //
// ./src/page/order/soldCreate/store/soldCreate.store.js